import React, { useEffect, useRef, useState } from "react";
import { storeAdvertInteraction } from "../services/advertService";

const AdvertPopup = ({ advert, show, onClose, position_key, useWebContent = false }) => {
  const [timer, setTimer] = useState(advert?.ads_dialog_time || 3);
  const [canClose, setCanClose] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);
  const hasTrackedView = useRef(false);

  useEffect(() => {
    if (show && advert) {
      setTimer(advert.ads_dialog_time || 3);
      setCanClose(false);
      setImageLoading(true);
      setImageError(false);
      hasTrackedView.current = false;
    }
  }, [show, advert]);

  useEffect(() => {
    if (show && advert && !hasTrackedView.current) {
      storeAdvertInteraction({
        position: position_key,
        adverts_id: advert.id,
        interaction_type: 0,
        web_url: window.location.href,
        useWebContent,
      }).catch(() => {});
      hasTrackedView.current = true;
    }
  }, [show, advert, position_key, useWebContent]);

  useEffect(() => {
    if (show && advert && !canClose && timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }

    if (timer <= 0) {
      setCanClose(true);
    }

    return undefined;
  }, [show, advert, timer, canClose]);

  if (!show || !advert) return null;

  const handleImageClick = () => {
    if (!advert.advert_url) {
      return;
    }

    storeAdvertInteraction({
      position: position_key,
      adverts_id: advert.id,
      interaction_type: 1,
      web_url: window.location.href,
      useWebContent,
    }).catch(() => {});
    window.open(advert.advert_url, "_blank", "noopener,noreferrer");
  };

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const handleImageError = () => {
    setImageLoading(false);
    setImageError(true);
  };

  return (
    <div
      className="modal fade show"
      tabIndex="-1"
      style={{
        display: "block",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        position: "fixed",
        inset: 0,
        zIndex: 1055,
        animation: "fadeIn 0.3s ease-in-out",
      }}
      aria-modal="true"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content border-0 shadow rounded-4 overflow-hidden position-relative">
          <div
            className="position-absolute top-0 end-0 m-3"
            style={{
              zIndex: 2,
              width: 32,
              height: 32,
              backgroundColor: "#6a49f2",
              color: "#fff",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "22px",
              fontWeight: "bold",
              marginTop: "-8px!important",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
            }}
          >
            {!canClose ? (
              <span>{timer}</span>
            ) : (
              <button
                className="crs-btn"
                type="button"
                onClick={onClose}
                aria-label="Close"
                style={{
                  all: "unset",
                  cursor: "pointer",
                  display: "flex",
                  alignContent: "center",
                  lineHeight: "normal !important",
                  fontSize: "22px !important",
                  marginTop: "-8px!important",
                }}
              >
                x
              </button>
            )}
          </div>

          {advert.name && (
            <div className="bg-white py-3 px-4 text-center border-bottom">
              <h5 className="mb-0 text-dark">{advert.name}</h5>
            </div>
          )}

          <div className="modal-body p-0 text-center bg-white position-relative">
            {advert.image_url && (
              <>
                {imageLoading && (
                  <div
                    style={{
                      height: "400px",
                      width: "100%",
                      background:
                        "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                      backgroundSize: "200% 100%",
                      animation: "shimmer 1.5s infinite",
                      borderRadius: "8px",
                      margin: "10px",
                    }}
                  />
                )}

                {imageError && (
                  <div
                    style={{
                      height: "400px",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      margin: "10px",
                      border: "2px dashed #dee2e6",
                    }}
                  >
                    <div className="text-center">
                      <i
                        className="fa fa-image"
                        style={{
                          fontSize: "48px",
                          color: "#6c757d",
                          marginBottom: "10px",
                        }}
                      />
                      <p className="text-muted mb-0">Image could not be loaded</p>
                    </div>
                  </div>
                )}

                <img
                  src={advert.image_url}
                  alt={advert.name || "Ad"}
                  onClick={handleImageClick}
                  className="img-fluid"
                  style={{
                    cursor: advert.advert_url ? "pointer" : "default",
                    maxHeight: 550,
                    width: "100%",
                    objectFit: "fill",
                    padding: "10px",
                    display: imageLoading || imageError ? "none" : "block",
                    transition: "opacity 0.3s ease-in-out",
                  }}
                  onLoad={handleImageLoad}
                  onError={handleImageError}
                />
              </>
            )}
          </div>

          {advert.description && (
            <div className="px-4 py-3 bg-light border-top">
              <p className="mb-0 text-secondary small text-center">{advert.description}</p>
            </div>
          )}
        </div>
      </div>

      <style>
        {`
          @keyframes shimmer {
            0% {
              background-position: -200% 0;
            }
            100% {
              background-position: 200% 0;
            }
          }
        `}
      </style>
    </div>
  );
};

export default AdvertPopup;
